import { OrderMutationErrorCode } from "../enums/orderMutationErrorCode";

export type OrderMutationMessageEntry = {
  translationKey: string;
  value: string;
};

/**
 * Canonical user-facing messages for OMS/inventory error codes.
 * Shared by ORDER_SERVICE_ALERT_MAP (alert banner) and ORDER_MUTATION_MESSAGES (modals).
 * Edit this file only when changing copy for these codes.
 */
export const SHARED_ORDER_MUTATION_ENTRIES: Record<
  OrderMutationErrorCode,
  OrderMutationMessageEntry
> = {
  [OrderMutationErrorCode.INVALID_STATE_TRANSITION]: {
    translationKey: "order-error-invalid-state-transition",
    value:
      "This action is not allowed for the current order state. Refresh the page, or use a draft order to add or change lines."
  },
  [OrderMutationErrorCode.ALREADY_RESERVED]: {
    translationKey: "order-error-already-reserved",
    value:
      "This order is not in draft, so you cannot add or change lines. Open a draft order or use the appropriate workflow for this status."
  },
  [OrderMutationErrorCode.DUPLICATE_ERROR]: {
    translationKey: "order-error-duplicate-conflict",
    value:
      "This action conflicts with existing data (e.g. duplicate or concurrent change). Try again or refresh."
  },
  [OrderMutationErrorCode.CONCURRENCY_ERROR]: {
    translationKey: "order-error-concurrency",
    value:
      "This order or inventory was updated elsewhere. Refresh and try again."
  },
  [OrderMutationErrorCode.INSUFFICIENT_STOCK]: {
    translationKey: "order-error-insufficient-stock",
    value: "Not enough stock available for this quantity."
  },
  [OrderMutationErrorCode.MISSING_ORDER_PAYLOAD]: {
    translationKey: "order-error-unexpected-response",
    value:
      "The server returned an unexpected response. Try again or refresh the page."
  },
  [OrderMutationErrorCode.MISSING_SCAN_PAYLOAD]: {
    translationKey: "order-error-unexpected-response",
    value:
      "The server returned an unexpected response. Try again or refresh the page."
  }
};
